/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GeogebraSessionInterface, ResultInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class GeogebraApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'Geogebra');
  }

  upsertGeogebra(ggbSession: GeogebraSessionInterface): Observable<ResultInterface> {
    const path = '';
    return this.post<ResultInterface>(path, undefined, ggbSession);
  }
}
